import React from 'react';
import { Handle, Position } from 'reactflow';
import { FaBrain } from 'react-icons/fa';

const ConditionNode = ({ data, isConnectable }) => {
  const isConfigured = data.config && Object.keys(data.config).length > 0;

  return (
    <div className={`custom-node cognition-node ${!isConfigured ? 'unconfigured' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        className="node-handle"
      />
      <div className="node-icon">
        <FaBrain />
      </div>
      <div className="node-content">
        <div className="node-label">{data.label}</div>
        {!isConfigured && <div className="node-status">Not configured</div>}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        className="node-handle"
      />
    </div>
  );
};

export default ConditionNode;

